import { removeLibraryCartItem, updateLibraryCartItemQuantity } from "./libraryCartUtils.jsx";

export default function LibraryCartQuickViewModal({ open, cartItems, onClose, onCartChanged, navigateToCheckout }) {
    if (!open) return null;

    const safeItems = Array.isArray(cartItems) ? cartItems : [];

    const handleQuantityChange = (itemId, value) => {
        const next = updateLibraryCartItemQuantity(itemId, value);
        if (onCartChanged) onCartChanged(next);
    };

    const handleRemove = (itemId) => {
        const next = removeLibraryCartItem(itemId);
        if (onCartChanged) onCartChanged(next);
    };

    const subtotal = safeItems.reduce((sum, item) => {
        const unitPrice = parseFloat(item.price);
        const quantity = parseInt(item.quantity, 10) || 1;
        const multiplier = parseFloat(item.discount_multiplier) || 1;
        if (isNaN(unitPrice)) return sum;
        return sum + unitPrice * multiplier * quantity;
    }, 0);

    return (
        <>
            <div className="library-modal-overlay" onClick={onClose} />
            <div className="library-modal library-cart-quickview-modal" role="dialog" aria-modal="true">
                <div className="library-modal-header">
                    <h3>Cart items ({safeItems.length})</h3>
                    <button className="library-slideover-close" onClick={onClose}>
                        Close
                    </button>
                </div>

                <div className="library-modal-body">
                    {safeItems.map((item) => (
                        <div key={item.id} className="library-cart-quickview-item">
                            <div className="library-cart-quickview-item-media">
                                {item.preview_image ? (
                                    <img src={item.preview_image} alt={item.name} draggable={false} />
                                ) : (
                                    <div className="library-cart-quickview-no-preview">3D</div>
                                )}
                            </div>
                            <div className="library-cart-quickview-item-main">
                                <strong>{item.name}</strong>
                                <div className="library-cart-quickview-item-labels">
                                    {Array.isArray(item.library_labels) &&
                                        item.library_labels.map((label, index) => (
                                            <span
                                                key={`${item.id}-${label.id ?? index}`}
                                                className="product-card-label-chip"
                                                style={label.color ? { backgroundColor: label.color } : {}}
                                            >
                                                {label.name}
                                            </span>
                                        ))}
                                </div>
                            </div>
                            <div className="library-cart-quickview-item-actions">
                                <div className="library-cart-quickview-qty">
                                    <label htmlFor={`library-cart-qty-${item.id}`}>Quantity</label>
                                    <input
                                        id={`library-cart-qty-${item.id}`}
                                        type="number"
                                        min={1}
                                        value={item.quantity || 1}
                                        onChange={(e) => handleQuantityChange(item.id, e.target.value)}
                                        readOnly={item.has_fixed_price === true}
                                        disabled={item.has_fixed_price === true}
                                        title={
                                            item.has_fixed_price === true
                                                ? "Quantity is fixed by the configured price agreement."
                                                : undefined
                                        }
                                    />
                                </div>
                                <button className="library-btn-delete" onClick={() => handleRemove(item.id)}>
                                    Remove
                                </button>
                            </div>
                        </div>
                    ))}

                    <div className="library-cart-quickview-footer">
                        <p>
                            Subtotal: <strong>€{subtotal.toFixed(2)}</strong>
                        </p>
                        <button className="library-cart-bar-add" onClick={navigateToCheckout}>
                            Go to checkout
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
